import { PageLoadEvents, track } from '@mc/track-event'

export const trackStickyFooterViewed = () =>
  track('Sticky Footer Viewed', {
    page_source: PageLoadEvents.PLANS,
  })
